var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pricing-filter-card mb-3",attrs:{"flat":"","outlined":""}},[_c('v-card-text',{staticClass:"py-3"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }